import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    justify-items: center;

    width: 100%;
    height: 56px;
    padding: 10px 25px;

    font-size: 20px;
    background: ${SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    LayoutIcon: styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;

    grid-column-start: 2;
    padding: 10px;

    cursor: pointer;
  `,
};
